<template>
  <div class="aui-wrapper aui-page__login">
    <div class="aui-content__wrapper">
      <main class="aui-content">
        <div class="login-header">
          <h2 class="login-brand">{{ $t('brand.lg') }}</h2>
        </div>
        <div class="login-body">
          <!-- <div class="tab-btn"
               @click="loginType=='10'?loginType='20':loginType='10'">
            {{loginType=='10'?'密码登录':'快捷登录注册'}}
          </div> -->
          <h3 class="login-title">{{'王帅18612341234 邀请您加入 中控技术股份有限公司'}}</h3>
          <el-form v-show="loginType=='10'"
                   label-position="left"
                   class="fast-login"
                   :model="fastDataForm"
                   :rules="dataRule1"
                   ref="fastDataForm"
                   @keyup.enter.native="fastDataFormSubmitHandle()"
                   status-icon>
            <el-form-item label="手机号码"
                          class="top-40"
                          label-width="100px"
                          prop="fastPhone">
              <el-input v-model="fastDataForm.fastPhone"
                        maxlength="20"
                        placeholder="输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="短信验证码"
                          label-width="100px"
                          prop="fastCaptcha">
              <el-input v-model="fastDataForm.fastCaptcha"
                        maxlength="20"
                        placeholder="输入验证码">
              </el-input>
              <el-button type="button"
                         class="absolute-right"
                         @click="sendcode"
                         :disabled="disabled"
                         v-if="disabled==false">发送验证码
              </el-button>
              <el-button type="button"
                         class="absolute-right"
                         @click="sendcode"
                         :disabled="disabled"
                         v-if="disabled==true">{{btntxt}}
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="registerAndAccept"
                         class="w-percent-100 top-40">{{pageType=='10'?'登录并接受邀请':'注册并接受邀请'}}</el-button>
            </el-form-item>
            <div class="tab-div">
              <span v-show="pageType=='10'"
                    @click="pageType='20'"
                    class="font-color-all">立即注册</span>
              <span v-show="pageType=='10'"
                    class="font-color-all"
                    @click="loginType=='10'?loginType='20':loginType='10'">密码登录</span>
              <span v-show="pageType=='20'"
                    @click="pageType='10'">已有账号 <span class="font-color-all">去登录</span></span>
            </div>
          </el-form>
          <!-- 密码登录 -->
          <el-form v-show="loginType=='20'"
                   :model="dataForm"
                   :rules="dataRule"
                   ref="dataForm"
                   @keyup.enter.native="dataFormSubmitHandle()"
                   status-icon>
            <!-- 中英文切换，先注释掉 -->
            <!-- <el-form-item>
              <el-select v-model="$i18n.locale"
                         class="w-percent-100">
                <el-option v-for="(val, key) in i18nMessages"
                           :key="key"
                           :label="val._lang"
                           :value="key"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item prop="username">
              <el-input v-model="dataForm.username"
                        maxlength="20"
                        placeholder="手机号或帐号">
                <span slot="prefix"
                      class="el-input__icon">
                  <svg class="icon-svg"
                       aria-hidden="true">
                    <use xlink:href="#icon-user"></use>
                  </svg>
                </span>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="dataForm.password"
                        type="password"
                        maxlength="20"
                        :placeholder="$t('login.password')">
                <span slot="prefix"
                      class="el-input__icon">
                  <svg class="icon-svg"
                       aria-hidden="true">
                    <use xlink:href="#icon-lock"></use>
                  </svg>
                </span>
              </el-input>
            </el-form-item>
            <!-- 验证码，先注释掉 -->
            <el-form-item prop="captcha">
              <el-row :gutter="20">
                <el-col :span="14">
                  <el-input v-model="dataForm.captcha"
                            maxlength="20"
                            :placeholder="$t('login.captcha')">
                    <span slot="prefix"
                          class="el-input__icon">
                      <svg class="icon-svg"
                           aria-hidden="true">
                        <use xlink:href="#icon-safetycertificate"></use>
                      </svg>
                    </span>
                  </el-input>
                </el-col>
                <el-col :span="10"
                        class="login-captcha">
                  <img :src="captchaPath"
                       @click="getCaptcha()">
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="dataFormSubmitHandle()"
                         class="w-percent-100">{{ $t('login.title') }}</el-button>
            </el-form-item>
            <div class="tab-div">
              <span class="font-color-all"
                    @click="loginType=='10'?loginType='20':loginType='10'">{{loginType=='10'?'密码登录':'手机登录'}}</span>
            </div>
          </el-form>
        </div>
      </main>
    </div>
  </div>
</template>
<script >
export default {
  data () {
    return {
      forgetPasswordVisible: false,
      registerVisible: false,
      captchaPath: '',
      dataForm: {
        username: '',
        password: '',
        uuid: '',
        captcha: '',
        grant_type: 'password'
      },
      fastDataForm: {
        fastPhone: '',
        fastCaptcha: ''
      },
      loginType: '10',
      disabled: false,
      time: 0,
      btntxt: '重新发送',
      pageType: '10'
    }
  },
  created () {
  },
  computed: {
    dataRule () {
      return {
        phone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    },
    dataRule1 () {
      return {
        phone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 手机验证发送验证码
    sendcode () {
      const reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/
      if (this.fastDataForm.fastPhone === '') {
        this.$message({
          message: '手机号不能为空',
          type: 'warning'
        })
        return
      }
      if (!reg.test(this.fastDataForm.fastPhone)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        })
        return false
      } else {
        this.time = 60
        this.disabled = true
        this.timer()
      }
    },
    // 60S倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后重新获取'
        this.$nextTick(() => {
          setTimeout(this.timer, 1000)
        })
      } else {
        this.time = 0
        this.btntxt = '获取验证码'
        this.disabled = false
      }
    },
    registerAndAccept () {

    }
  }
}
</script>
<style lang='scss' scoped>
.font-color-all {
  font-size: 14px;
}
.login-body {
  position: relative;
}
.tab-btn {
  position: absolute;
  color: #1d65a8;
  right: 30px;
  cursor: pointer;
}
.tab-div {
  display: flex;
  justify-content: space-between;
}
.login-title {
  font-size: 14px !important;
}
</style>
